import urlParameter from '@hc-frontend/shared-assets/src/js/utils/url/urlParameter'
import standardizeMembers from 'utils/store/standardize/standardizeMembers'
import getAgentLoggedId from 'utils/pivot/agent/getAgentLoggedId'
import updateByQuoteKey from 'core/initPage/updateByQuoteKey'
import getValidEndDate from 'core/controllers/getEndDate'
import setStartDate from 'core/controllers/setStartDate'
import { findChildren } from '@hc-frontend/business'
import { MemberType } from '@hc-frontend/entities'
import sanitize from 'utils/DOM/sanitize'
import storage from 'proxy-storage'
import {
  getHcStorageFromQuery,
  mergeHcStorage,
  initHcStorage
} from './hcStorageInitTools'

function getMembersWithNamesUpdated(originalMembers, hcStorage) {
  const standardOriginalMembers = standardizeMembers(originalMembers)
  const children = findChildren(standardOriginalMembers)

  return standardizeMembers(hcStorage.members).map((member, index) => {
    const nameOwner =
      member.type.toLowerCase() !== MemberType.Child
        ? standardOriginalMembers.find(({ type }) => type === member.type)
        : children.shift()

    return {
      ...hcStorage.members[index],
      firstName: nameOwner?.firstName || '',
      lastName: nameOwner?.lastName || '',
      id: hcStorage.members[index].id || nameOwner?.id
    }
  })
}

async function getContext({
  clearStorage
}: {
  clearStorage?: boolean
  updateLocation?: boolean
}): Promise<Pivot.Store> {
  const quoteKey = urlParameter('quoteKey')
  const gclid = urlParameter('gclid')
  const agentCloudOpportunityId = urlParameter('agentcloudOpportunityId')

  let hcStorage = mergeHcStorage(initHcStorage(clearStorage), getHcStorageFromQuery())

  const originalMembers = hcStorage.members
  hcStorage = (quoteKey && (await updateByQuoteKey(hcStorage, quoteKey))) || hcStorage

  if (!quoteKey) {
    hcStorage.agent_id =
      getAgentLoggedId() || urlParameter('agent_id') || hcStorage.agent_id || 2010000

    const newStartDate = setStartDate(hcStorage.sdate)
    const endDate = urlParameter('endDate') || hcStorage.endDate || ''
    hcStorage.endDate = getValidEndDate(hcStorage.sdate, newStartDate, endDate)

    hcStorage.originalSDate = hcStorage.sdate
    hcStorage.sdate = newStartDate
  }

  // Sometimes agent_id comes with a white space from the URL. Eg. '%2031785' instead of '31785'
  if (typeof hcStorage.agent_id === 'string') {
    hcStorage.agent_id = hcStorage.agent_id.trim()
  }

  if (quoteKey) {
    hcStorage.members = getMembersWithNamesUpdated(originalMembers, hcStorage)
  }

  if (agentCloudOpportunityId) {
    hcStorage.agentCloudOpportunityId = agentCloudOpportunityId
  }

  if (gclid && window.location.pathname.includes('aflac')) {
    const utm = { ...hcStorage.utm, utm_term: gclid }

    storage.setItem('hc', { ...hcStorage, utm })
  }

  return sanitize(hcStorage)
}

export default getContext
